export default __webpack_public_path__ + "static/media/gteng.aeedb92d.png";